// extracted by mini-css-extract-plugin
export default {"btn_wrapp":"Pagination_btn_wrapp__Nz6RS","btn":"Pagination_btn__ZXEZs","activeBtn":"Pagination_activeBtn__qvRPT","container":"Pagination_container__PIhkj"};